function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_orderstatus_of:customdeploy_ns_sc_ext_sl_orderstatus_of":"/app/site/hosting/scriptlet.nl?script=2014&deploy=1&compid=4453441&ns-at=AAEJ7tMQ4ZVcPHx_swvY_Vz5xgMVJ6l4dB8_f83IiW8r8Z0S2xA","customscript_ns_sc_sl_blog_entity_loader:customdeploy_ns_sc_sl_blog_entity_loader":"/app/site/hosting/scriptlet.nl?script=1995&deploy=1&compid=4453441&ns-at=AAEJ7tMQHSiQNbU-YudjGM8TsaltAwzRoYUwtTMo4Oq0u2COuAA","customscript_ns_sc_sl_blog_post_searcher:customdeploy_ns_sc_sl_blog_post_searcher":"/app/site/hosting/scriptlet.nl?script=1997&deploy=1&compid=4453441&ns-at=AAEJ7tMQ0tNbqeJBx3QJjY3BilaskCwRneawwNMYubm5gz58bs8","customscript_ns_sc_sl_blog_url_prov:customdeploy_ns_sc_sl_blog_url_prov_dep":"/app/site/hosting/scriptlet.nl?script=1996&deploy=1&compid=4453441&ns-at=AAEJ7tMQlPOmOzYU43y_lu0k3Y28COzFt5CRMpgTxUIi_CDtJnA","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=460&deploy=1&compid=4453441&ns-at=AAEJ7tMQcGHw7Hq-8YsZh3S3qCE3e-fsu-qCi35iyb98cPp7-mM","customscript_ns_sc_sl_gift_cert_balance:customdeploy_ns_sc_sl_gift_cert_balance":"/app/site/hosting/scriptlet.nl?script=1833&deploy=1&compid=4453441&ns-at=AAEJ7tMQDE6fDSC2oHoFxcpeUuYgvPgencxCQ8ilfxEmb3-jkyY","customscript_ns_sc_sl_gift_cert_groups:customdeploy_ns_sc_sl_gift_cert_groups":"/app/site/hosting/scriptlet.nl?script=1834&deploy=1&compid=4453441&ns-at=AAEJ7tMQNmi9DVe1LWWspaYANAATQuj9YUSdp6V-Pjs5J7pF624","customscript_ns_sc_sl_gift_cert_mgmt:customdeploy_ns_sc_sl_gift_cert_mgmt":"/app/site/hosting/scriptlet.nl?script=1835&deploy=1&compid=4453441&ns-at=AAEJ7tMQzicl4cc_FQogLtUSB8hI08wYShMXAYbOPzcheOX08oY"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}